import { createQueryKeys } from '@lukemorales/query-key-factory';

export const contactsKeys = createQueryKeys('contacts', {
  all: null,
});
